/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Signup_Compare_Who_StarterInputs */



/**
* | output |
* | --- |
* | "For individuals and freelancers" |
*
* @param {Signup_Compare_Who_StarterInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const signup_compare_who_starter = /** @type {((inputs?: Signup_Compare_Who_StarterInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Signup_Compare_Who_StarterInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("For individuals and freelancers")
	if (locale === "de") return /** @type {LocalizedString} */ ("For individuals and freelancers")
	if (locale === "it") return /** @type {LocalizedString} */ ("For individuals and freelancers")
	if (locale === "ru") return /** @type {LocalizedString} */ ("For individuals and freelancers")
	if (locale === "es") return /** @type {LocalizedString} */ ("For individuals and freelancers")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("For individuals and freelancers")
	if (locale === "ja") return /** @type {LocalizedString} */ ("For individuals and freelancers")
	if (locale === "hi") return /** @type {LocalizedString} */ ("For individuals and freelancers")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("For individuals and freelancers")
	return /** @type {LocalizedString} */ ("For individuals and freelancers")
});